import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ObjectType, TranslateForCrmObjectPipe } from '@galaxy/crm/static';

@Component({
  selector: 'crm-profile-footer',
  templateUrl: './profile-footer.component.html',
  styleUrls: ['./profile-footer.component.scss'],
  imports: [CommonModule, MatButtonModule, TranslateForCrmObjectPipe],
})
export class CrmProfileFooterComponent {
  @Input({ required: true }) objectType!: ObjectType;
  @Input({ required: true }) onClickEdit!: () => void | Promise<void>;
}
